module.exports = __webpack_public_path__ + "static/img/ilustrative-image-character.67667f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ilustrative-image-character.jpg
// module id = 1s0f
// module chunks = 1